import { getContext } from '@fiverr-private/fiverr_context';
import { inExperiment } from '../index';
import { PackageData } from '../../../types/gig/interfaces';
import { hasPackageWithIdOneAndMinimumPrice } from './hasPackageWithIdOneAndMinimumPrice';

const LYNXES_GIG_PAGE_CTA_REWORK = 5048;

/**
 * Checks if user is in the Lynxes CTA Rework test
 * Requires package with id === 1 and price >= 10000 (same as allocation logic)
 * @param packageList - Array of packages from Redux store (state.packages.packageList)
 * @returns {boolean} true if user is in experiment and has package with id 1 and price >= 10000 (100 USD)
 */
export const isInLynxesCtaReworkTest = (packageList: PackageData[]) => {
    const { abTests } = getContext();

    if (!hasPackageWithIdOneAndMinimumPrice(packageList)) {
        return false;
    }

    return inExperiment(LYNXES_GIG_PAGE_CTA_REWORK, abTests);
};
